export default function text_chart_getter(chart) {
	let ret = {
		value: chart.options("Value").toString(),
		label: chart.options("Label"),
		color: chart.options("PrimaryColor"),
		textColor: "#000000",
	};
	return ([ret]);
}
